const englishQuestions = [


{
  question: "My father ___ a teacher.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "The children ___ playing outside.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "She has ___ her bag.",
  options: ["lose", "lost", "losing", "loses"],
  answer: "lost"
},
{
  question: "We ___ the work yesterday.",
  options: ["finish", "finished", "finishing", "finishes"],
  answer: "finished"
},
{
  question: "Kofi and Kojo ___ friends.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "The teacher ___ the lesson.",
  options: ["explain", "explains", "explained", "explaining"],
  answer: "explains"
},
{
  question: "I ___ watching TV when he came.",
  options: ["was", "were", "is", "be"],
  answer: "was"
},
{
  question: "They ___ already left.",
  options: ["has", "have", "had", "having"],
  answer: "have"
},
{
  question: "A dog ___ barking loudly.",
  options: ["is", "are", "were", "be"],
  answer: "is"
},
{
  question: "Everyone ___ happy.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "The man ___ eating.",
  options: ["is", "are", "were", "be"],
  answer: "is"
},
{
  question: "She ___ a letter now.",
  options: ["write", "writes", "is writing", "written"],
  answer: "is writing"
},
{
  question: "We ___ our work already.",
  options: ["finish", "have finished", "finished", "finishing"],
  answer: "have finished"
},
{
  question: "He ___ football every Sunday.",
  options: ["play", "plays", "played", "playing"],
  answer: "plays"
},
{
  question: "The baby ___ crying.",
  options: ["is", "are", "were", "be"],
  answer: "is"
},
{
  question: "Ama ___ to the market.",
  options: ["go", "goes", "went", "going"],
  answer: "goes"
},
{
  question: "We ___ studying English.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "He ___ never been there.",
  options: ["has", "have", "had", "having"],
  answer: "has"
},
{
  question: "The girl ___ singing.",
  options: ["is", "are", "were", "be"],
  answer: "is"
},
{
  question: "I ___ a book yesterday.",
  options: ["read", "reads", "reading", "readed"],
  answer: "read"
},
{
  question: "They ___ going home.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Kofi ___ eaten.",
  options: ["has", "have", "had", "having"],
  answer: "has"
},
{
  question: "We ___ to school daily.",
  options: ["go", "goes", "went", "gone"],
  answer: "go"
},
{
  question: "She ___ finished eating.",
  options: ["has", "have", "had", "having"],
  answer: "has"
},
{
  question: "The boys ___ running.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "I ___ tired.",
  options: ["is", "am", "are", "be"],
  answer: "am"
},
{
  question: "You ___ late.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "He ___ a car.",
  options: ["have", "has", "had", "having"],
  answer: "has"
},
{
  question: "We ___ seen him.",
  options: ["has", "have", "had", "having"],
  answer: "have"
},
{
  question: "The dog ___ barking.",
  options: ["is", "are", "was", "be"],
  answer: "is"
},

{
  question: "Neither the teacher nor the students ___ aware of the change.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "The number of applicants ___ increasing every year.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "A number of students ___ absent today.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "By this time next year, she ___ her degree.",
  options: ["completes", "will complete", "will have completed", "has completed"],
  answer: "will have completed"
},
{
  question: "Hardly had he arrived ___ the rain started.",
  options: ["when", "than", "that", "then"],
  answer: "when"
},
{
  question: "No sooner had they left ___ the accident occurred.",
  options: ["when", "than", "that", "then"],
  answer: "than"
},
{
  question: "If he ___ harder, he would have passed.",
  options: ["studies", "studied", "had studied", "study"],
  answer: "had studied"
},
{
  question: "Were I you, I ___ the offer.",
  options: ["accept", "would accept", "accepted", "will accept"],
  answer: "would accept"
},
{
  question: "She behaves as if she ___ everything.",
  options: ["knows", "knew", "known", "know"],
  answer: "knew"
},
{
  question: "It is high time we ___ home.",
  options: ["go", "went", "gone", "going"],
  answer: "went"
},
{
  question: "The committee ___ divided in their opinions.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Bread and butter ___ his favorite meal.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "Each of the players ___ given a medal.",
  options: ["were", "are", "was", "have"],
  answer: "was"
},
{
  question: "Either the manager or the workers ___ responsible.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "The news ___ surprising.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "Mathematics ___ my best subject.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "The police ___ investigating the case.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Ten dollars ___ enough for the book.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "Not only the teacher but also the students ___ excited.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "He, as well as his friends, ___ present.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "She would rather you ___ earlier.",
  options: ["come", "came", "coming", "comes"],
  answer: "came"
},
{
  question: "If I ___ you, I would reconsider.",
  options: ["am", "were", "was", "be"],
  answer: "were"
},
{
  question: "The more he studies, the ___ he becomes.",
  options: ["intelligent", "more intelligent", "most intelligent", "intelligence"],
  answer: "more intelligent"
},
{
  question: "Scarcely had he spoken ___ they interrupted him.",
  options: ["when", "than", "that", "then"],
  answer: "when"
},
{
  question: "She is one of the girls who ___ always punctual.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "This is the only one of the boys who ___ completed the task.",
  options: ["have", "has", "had", "having"],
  answer: "has"
},
{
  question: "I wish I ___ taller.",
  options: ["am", "were", "was", "be"],
  answer: "were"
},
{
  question: "He talks as though he ___ the owner.",
  options: ["is", "was", "were", "be"],
  answer: "were"
},
{
  question: "If she ___ earlier, she would catch the bus.",
  options: ["leaves", "left", "had left", "leave"],
  answer: "left"
},
{
  question: "Neither of the answers ___ correct.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "A bouquet of flowers ___ on the table.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "The quality of the goods ___ poor.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "My friend and colleague ___ arriving today.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "The teacher together with the students ___ going on a trip.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "It is required that every student ___ present.",
  options: ["is", "be", "was", "are"],
  answer: "be"
},
{
  question: "He demanded that she ___ immediately.",
  options: ["leave", "leaves", "left", "leaving"],
  answer: "leave"
},
{
  question: "She suggested that he ___ harder.",
  options: ["study", "studies", "studied", "studying"],
  answer: "study"
},
{
  question: "The jury ___ divided in their verdict.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Time and tide ___ for no man.",
  options: ["wait", "waits", "waiting", "waited"],
  answer: "wait"
},
{
  question: "The rich ___ getting richer.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},

{
  question: "Neither the principal nor the teachers ___ aware of the new policy.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "The number of candidates ___ increased significantly.",
  options: ["have", "has", "are", "were"],
  answer: "has"
},
{
  question: "A number of issues ___ yet to be resolved.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "By next month, she ___ in this office for ten years.",
  options: ["works", "will work", "will have worked", "has worked"],
  answer: "will have worked"
},
{
  question: "Hardly had the meeting started ___ the lights went off.",
  options: ["when", "than", "that", "then"],
  answer: "when"
},
{
  question: "No sooner had he entered ___ everyone stood up.",
  options: ["when", "than", "that", "then"],
  answer: "than"
},
{
  question: "If she ___ the instructions, she would not have failed.",
  options: ["follows", "followed", "had followed", "follow"],
  answer: "had followed"
},
{
  question: "Were he more careful, he ___ fewer mistakes.",
  options: ["makes", "would make", "made", "will make"],
  answer: "would make"
},
{
  question: "She speaks as if she ___ the whole story.",
  options: ["knows", "knew", "known", "know"],
  answer: "knew"
},
{
  question: "It is time we ___ the matter seriously.",
  options: ["take", "took", "taken", "taking"],
  answer: "took"
},
{
  question: "The committee ___ divided in its opinion.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Bread and eggs ___ his usual breakfast.",
  options: ["are", "is", "was", "be"],
  answer: "is"
},
{
  question: "Each of the candidates ___ given equal opportunity.",
  options: ["were", "are", "was", "have"],
  answer: "was"
},
{
  question: "Either the manager or his assistants ___ to blame.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "The information ___ not accurate.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "Physics ___ considered a difficult subject.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "The police ___ searching the area.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Five thousand cedis ___ a large amount.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "Not only the players but also the coach ___ satisfied.",
  options: ["is", "are", "was", "be"],
  answer: "is"
},
{
  question: "The teacher, along with the students, ___ attending the seminar.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},

{
  question: "Identify the error: She did not went to school yesterday.",
  options: ["did not", "went", "school", "yesterday"],
  answer: "went"
},
{
  question: "Identify the error: He has ate the food already.",
  options: ["has", "ate", "food", "already"],
  answer: "ate"
},
{
  question: "Identify the error: The teacher along with the students are going.",
  options: ["teacher", "along with", "are", "going"],
  answer: "are"
},
{
  question: "Identify the error: Each of the boys have a pen.",
  options: ["each", "boys", "have", "pen"],
  answer: "have"
},
{
  question: "Identify the error: She is more smarter than her sister.",
  options: ["is", "more", "smarter", "than"],
  answer: "more"
},
{
  question: "Choose the correct sentence:",
  options: [
    "He don’t know the answer",
    "He doesn’t knows the answer",
    "He doesn’t know the answer",
    "He not know the answer"
  ],
  answer: "He doesn’t know the answer"
},
{
  question: "Choose the correct sentence:",
  options: [
    "I am used to wake early",
    "I am used to waking early",
    "I am use to waking early",
    "I am used waking early"
  ],
  answer: "I am used to waking early"
},
{
  question: "Identify the error: She prefers tea than coffee.",
  options: ["prefers", "tea", "than", "coffee"],
  answer: "than"
},
{
  question: "Correct sentence:",
  options: [
    "He is good in Mathematics",
    "He is good at Mathematics",
    "He is good on Mathematics",
    "He is good with Mathematics"
  ],
  answer: "He is good at Mathematics"
},
{
  question: "Identify the error: One of the girls have lost her book.",
  options: ["one", "girls", "have", "lost"],
  answer: "have"
},
{
  question: "Identify the error: The equipments are new.",
  options: ["equipments", "are", "new", "the"],
  answer: "equipments"
},
{
  question: "Correct sentence:",
  options: [
    "She is married with a doctor",
    "She is married to a doctor",
    "She is married by a doctor",
    "She is married from a doctor"
  ],
  answer: "She is married to a doctor"
},
{
  question: "Identify the error: I am looking forward to see you.",
  options: ["looking", "forward", "to see", "you"],
  answer: "to see"
},
{
  question: "Correct sentence:",
  options: [
    "He insisted to go",
    "He insisted on going",
    "He insisted go",
    "He insisted for going"
  ],
  answer: "He insisted on going"
},
{
  question: "Identify the error: She has less books than me.",
  options: ["has", "less", "books", "me"],
  answer: "less"
},
{
  question: "Correct sentence:",
  options: [
    "Between you and I",
    "Between you and me",
    "Between I and you",
    "Between me and I"
  ],
  answer: "Between you and me"
},
{
  question: "Identify the error: He is capable to do the work.",
  options: ["capable", "to do", "work", "he"],
  answer: "to do"
},
{
  question: "Correct sentence:",
  options: [
    "She is afraid from dogs",
    "She is afraid of dogs",
    "She is afraid on dogs",
    "She is afraid with dogs"
  ],
  answer: "She is afraid of dogs"
},
{
  question: "Identify the error: The sceneries are beautiful.",
  options: ["sceneries", "are", "beautiful", "the"],
  answer: "sceneries"
},
{
  question: "Correct sentence:",
  options: [
    "He denied to steal the money",
    "He denied stealing the money",
    "He denied steal the money",
    "He denied for stealing the money"
  ],
  answer: "He denied stealing the money"
},

{
  question: "He is fond ___ playing football.",
  options: ["of", "in", "on", "with"],
  answer: "of"
},
{
  question: "She is married ___ a doctor.",
  options: ["with", "to", "by", "from"],
  answer: "to"
},
{
  question: "We arrived ___ the airport early.",
  options: ["in", "at", "on", "to"],
  answer: "at"
},
{
  question: "He insisted ___ paying the bill.",
  options: ["to", "on", "for", "at"],
  answer: "on"
},
{
  question: "She is afraid ___ snakes.",
  options: ["of", "from", "on", "with"],
  answer: "of"
},
{
  question: "He is good ___ Mathematics.",
  options: ["in", "on", "at", "with"],
  answer: "at"
},
{
  question: "The book belongs ___ me.",
  options: ["to", "with", "for", "at"],
  answer: "to"
},
{
  question: "He is tired ___ working.",
  options: ["from", "of", "with", "by"],
  answer: "of"
},
{
  question: "She apologized ___ being late.",
  options: ["for", "to", "with", "at"],
  answer: "for"
},
{
  question: "He is interested ___ music.",
  options: ["on", "in", "at", "with"],
  answer: "in"
},
{
  question: "Choose the correct idiom: He finally kicked the bucket.",
  options: ["died", "ran away", "won", "failed"],
  answer: "died"
},
{
  question: "Choose the correct idiom: She spilled the beans.",
  options: ["revealed a secret", "cooked food", "made a mess", "cried"],
  answer: "revealed a secret"
},
{
  question: "Choose the correct idiom: He is under the weather.",
  options: ["sick", "happy", "angry", "busy"],
  answer: "sick"
},
{
  question: "Choose the correct idiom: They hit the nail on the head.",
  options: ["correct", "wrong", "angry", "late"],
  answer: "correct"
},
{
  question: "Choose the correct idiom: He let the cat out of the bag.",
  options: ["revealed secret", "caught animal", "ran away", "lied"],
  answer: "revealed secret"
},
{
  question: "Choose the correct idiom: She is on cloud nine.",
  options: ["very happy", "sad", "angry", "confused"],
  answer: "very happy"
},
{
  question: "Choose the correct idiom: He broke the ice.",
  options: ["started conversation", "destroyed", "fell", "failed"],
  answer: "started conversation"
},
{
  question: "Choose the correct idiom: They burned the midnight oil.",
  options: ["studied late", "burned house", "slept", "worked morning"],
  answer: "studied late"
},
{
  question: "Choose the correct idiom: She once in a blue moon visits.",
  options: ["rarely", "often", "daily", "always"],
  answer: "rarely"
},
{
  question: "Choose the correct idiom: He is a black sheep.",
  options: ["bad member", "good member", "leader", "strong"],
  answer: "bad member"
},

{
  question: "The manager’s decision was arbitrary. 'Arbitrary' means:",
  options: ["random", "planned", "fair", "legal"],
  answer: "random"
},
{
  question: "He gave a vague explanation. 'Vague' means:",
  options: ["unclear", "detailed", "correct", "precise"],
  answer: "unclear"
},
{
  question: "The results were astounding. 'Astounding' means:",
  options: ["surprising", "boring", "expected", "simple"],
  answer: "surprising"
},
{
  question: "She is very diligent in her work. 'Diligent' means:",
  options: ["hardworking", "lazy", "careless", "slow"],
  answer: "hardworking"
},
{
  question: "The boy was reprimanded for his actions. 'Reprimanded' means:",
  options: ["scolded", "praised", "ignored", "rewarded"],
  answer: "scolded"
},
{
  question: "He is notorious for lying. 'Notorious' means:",
  options: ["well-known (bad)", "famous (good)", "unknown", "honest"],
  answer: "well-known (bad)"
},
{
  question: "Her answer was concise. 'Concise' means:",
  options: ["brief", "long", "confusing", "incorrect"],
  answer: "brief"
},
{
  question: "The task was tedious. 'Tedious' means:",
  options: ["boring", "easy", "exciting", "short"],
  answer: "boring"
},
{
  question: "He is very arrogant. 'Arrogant' means:",
  options: ["proud", "humble", "kind", "polite"],
  answer: "proud"
},
{
  question: "She was reluctant to speak. 'Reluctant' means:",
  options: ["unwilling", "eager", "happy", "ready"],
  answer: "unwilling"
},
{
  question: "Choose the opposite of 'abundant':",
  options: ["scarce", "plenty", "many", "full"],
  answer: "scarce"
},
{
  question: "Choose the opposite of 'expand':",
  options: ["contract", "grow", "increase", "develop"],
  answer: "contract"
},
{
  question: "Choose the opposite of 'ancient':",
  options: ["modern", "old", "historic", "aged"],
  answer: "modern"
},
{
  question: "Choose the opposite of 'generous':",
  options: ["selfish", "kind", "friendly", "giving"],
  answer: "selfish"
},
{
  question: "Choose the opposite of 'victory':",
  options: ["defeat", "success", "win", "triumph"],
  answer: "defeat"
},
{
  question: "The weather was harsh. 'Harsh' means:",
  options: ["severe", "mild", "pleasant", "soft"],
  answer: "severe"
},
{
  question: "The speech was inspiring. 'Inspiring' means:",
  options: ["motivating", "boring", "confusing", "dull"],
  answer: "motivating"
},
{
  question: "He made a deliberate mistake. 'Deliberate' means:",
  options: ["intentional", "accidental", "careless", "quick"],
  answer: "intentional"
},
{
  question: "She showed compassion. 'Compassion' means:",
  options: ["kindness", "anger", "fear", "hate"],
  answer: "kindness"
},
{
  question: "The plan was feasible. 'Feasible' means:",
  options: ["possible", "impossible", "difficult", "wrong"],
  answer: "possible"
},

{
  question: "Passage: The student studied consistently and avoided distractions, which helped him excel in his exams.\n\nQuestion: What mainly led to his success?",
  options: ["luck", "consistent study", "teacher support", "natural ability"],
  answer: "consistent study"
},
{
  question: "Passage: Although the road was rough, the driver maintained control of the vehicle.\n\nQuestion: What quality did the driver show?",
  options: ["fear", "skill", "anger", "carelessness"],
  answer: "skill"
},
{
  question: "Passage: The manager reduced prices to attract more customers to the business.\n\nQuestion: Why were prices reduced?",
  options: ["to increase costs", "to attract customers", "to reduce profit", "to compete poorly"],
  answer: "to attract customers"
},
{
  question: "Passage: The boy refused to apologize despite being clearly at fault.\n\nQuestion: What trait does the boy display?",
  options: ["honesty", "stubbornness", "kindness", "fear"],
  answer: "stubbornness"
},
{
  question: "Passage: The team worked together effectively, leading to a successful outcome.\n\nQuestion: What caused their success?",
  options: ["individual effort", "teamwork", "luck", "resources"],
  answer: "teamwork"
},
{
  question: "Passage: She spoke softly so as not to disturb others in the room.\n\nQuestion: Why did she speak softly?",
  options: ["fear", "respect", "anger", "weakness"],
  answer: "respect"
},
{
  question: "Passage: The farmer harvested more crops due to adequate rainfall during the season.\n\nQuestion: What contributed to the high yield?",
  options: ["fertilizer", "rainfall", "labor", "tools"],
  answer: "rainfall"
},
{
  question: "Passage: He ignored the warning signs and continued the dangerous activity.\n\nQuestion: What does this show?",
  options: ["wisdom", "carelessness", "discipline", "intelligence"],
  answer: "carelessness"
},
{
  question: "Passage: The teacher explained the lesson clearly, making it easy for students to understand.\n\nQuestion: What made the lesson effective?",
  options: ["student effort", "clear explanation", "short time", "notes"],
  answer: "clear explanation"
},
{
  question: "Passage: She saved money regularly to prepare for future needs.\n\nQuestion: What quality does she show?",
  options: ["greed", "planning", "fear", "wastefulness"],
  answer: "planning"
},
{
  question: "Passage: The child cried after falling from the bicycle.\n\nQuestion: Why did the child cry?",
  options: ["fear", "pain", "anger", "hunger"],
  answer: "pain"
},
{
  question: "Passage: The company introduced new technology, increasing efficiency significantly.\n\nQuestion: What was the effect of the new technology?",
  options: ["reduced efficiency", "increased efficiency", "higher cost", "worker loss"],
  answer: "increased efficiency"
},
{
  question: "Passage: The athlete trained daily, which improved his performance.\n\nQuestion: What improved his performance?",
  options: ["training", "diet", "coach", "luck"],
  answer: "training"
},
{
  question: "Passage: The environment was polluted due to improper waste disposal.\n\nQuestion: What caused the pollution?",
  options: ["weather", "waste disposal", "industry", "traffic"],
  answer: "waste disposal"
},
{
  question: "Passage: She completed the task despite facing many challenges.\n\nQuestion: What does this show?",
  options: ["weakness", "determination", "fear", "anger"],
  answer: "determination"
},
{
  question: "Passage: The match was postponed because of heavy rainfall.\n\nQuestion: Why was the match postponed?",
  options: ["lack of players", "rainfall", "poor planning", "injury"],
  answer: "rainfall"
},
{
  question: "Passage: He answered confidently, even though he was unsure.\n\nQuestion: What does 'confidently' suggest?",
  options: ["fear", "boldness", "confusion", "weakness"],
  answer: "boldness"
},
{
  question: "Passage: The students celebrated after passing their exams.\n\nQuestion: Why did they celebrate?",
  options: ["they were tired", "they passed", "they traveled", "they rested"],
  answer: "they passed"
},
{
  question: "Passage: The road was slippery, so drivers reduced speed.\n\nQuestion: Why did drivers slow down?",
  options: ["traffic", "slippery road", "police", "darkness"],
  answer: "slippery road"
},
{
  question: "Passage: The boy hesitated before answering because he was unsure.\n\nQuestion: Why did he hesitate?",
  options: ["confidence", "uncertainty", "anger", "fear"],
  answer: "uncertainty"
},

{
  question: "Passage: Technology has improved communication but has also reduced face-to-face interaction.\n\nQuestion: Which is the best summary?",
  options: [
    "Technology improves communication but reduces personal interaction",
    "Technology is bad",
    "Communication is slow",
    "People do not talk anymore"
  ],
  answer: "Technology improves communication but reduces personal interaction"
},
{
  question: "Passage: Regular exercise improves health, increases energy, and reduces stress.\n\nQuestion: Which is the best summary?",
  options: [
    "Exercise has many health benefits",
    "Exercise is stressful",
    "Exercise wastes time",
    "Exercise is difficult"
  ],
  answer: "Exercise has many health benefits"
},
{
  question: "Passage: Discipline and consistency help students achieve success more than natural intelligence alone.\n\nQuestion: Which is the best summary?",
  options: [
    "Success depends more on discipline than intelligence",
    "Intelligence is everything",
    "Students are lazy",
    "Success is impossible"
  ],
  answer: "Success depends more on discipline than intelligence"
},
{
  question: "Passage: Pollution from factories and vehicles has led to environmental damage and health problems.\n\nQuestion: Which is the best summary?",
  options: [
    "Pollution causes environmental and health issues",
    "Factories are useful",
    "Vehicles are fast",
    "Health is improving"
  ],
  answer: "Pollution causes environmental and health issues"
},
{
  question: "Passage: Saving money regularly helps individuals prepare for emergencies and future needs.\n\nQuestion: Which is the best summary?",
  options: [
    "Saving money is important for the future",
    "Money is not useful",
    "Spending is better",
    "People save daily"
  ],
  answer: "Saving money is important for the future"
},
{
  question: "Passage: Teamwork improves productivity because people combine skills and support one another.\n\nQuestion: Which is the best summary?",
  options: [
    "Teamwork increases productivity",
    "Working alone is better",
    "People dislike teamwork",
    "Skills are useless"
  ],
  answer: "Teamwork increases productivity"
},
{
  question: "Passage: Reading regularly expands vocabulary, improves comprehension, and develops critical thinking.\n\nQuestion: Which is the best summary?",
  options: [
    "Reading improves language and thinking skills",
    "Reading is boring",
    "Reading wastes time",
    "Reading is difficult"
  ],
  answer: "Reading improves language and thinking skills"
},
{
  question: "Passage: Poor time management leads to stress, missed deadlines, and reduced performance.\n\nQuestion: Which is the best summary?",
  options: [
    "Poor time management causes problems",
    "Time is not important",
    "Deadlines are useless",
    "Stress is good"
  ],
  answer: "Poor time management causes problems"
},
{
  question: "Passage: Good leadership involves communication, decision-making, and responsibility.\n\nQuestion: Which is the best summary?",
  options: [
    "Leadership requires key skills",
    "Leaders talk too much",
    "Leaders are strict",
    "Leadership is easy"
  ],
  answer: "Leadership requires key skills"
},
{
  question: "Passage: Education provides knowledge, builds character, and prepares individuals for the future.\n\nQuestion: Which is the best summary?",
  options: [
    "Education is essential for development",
    "Education is difficult",
    "Education is optional",
    "Knowledge is useless"
  ],
  answer: "Education is essential for development"
},
{
  question: "Passage: Hard work and persistence enable individuals to overcome challenges and achieve their goals.\n\nQuestion: Which is the best summary?",
  options: [
    "Hard work leads to success",
    "Challenges are impossible",
    "Goals are useless",
    "Persistence is weak"
  ],
  answer: "Hard work leads to success"
},
{
  question: "Passage: Social media allows communication but can lead to distraction and reduced productivity.\n\nQuestion: Which is the best summary?",
  options: [
    "Social media has benefits and drawbacks",
    "Social media is perfect",
    "Social media is useless",
    "Communication is bad"
  ],
  answer: "Social media has benefits and drawbacks"
},
{
  question: "Passage: Healthy eating habits improve body function and reduce the risk of disease.\n\nQuestion: Which is the best summary?",
  options: [
    "Healthy eating improves health",
    "Food is unnecessary",
    "Eating causes illness",
    "Health is automatic"
  ],
  answer: "Healthy eating improves health"
},
{
  question: "Passage: Effective communication prevents misunderstandings and strengthens relationships.\n\nQuestion: Which is the best summary?",
  options: [
    "Communication improves relationships",
    "Misunderstanding is good",
    "Talking is unnecessary",
    "Relationships are weak"
  ],
  answer: "Communication improves relationships"
},
{
  question: "Passage: Laziness often leads to failure because tasks are not completed on time.\n\nQuestion: Which is the best summary?",
  options: [
    "Laziness leads to failure",
    "Failure is good",
    "Time is not important",
    "Tasks are useless"
  ],
  answer: "Laziness leads to failure"
},
{
  question: "Passage: Planning helps individuals organize tasks and use time efficiently.\n\nQuestion: Which is the best summary?",
  options: [
    "Planning improves efficiency",
    "Planning wastes time",
    "Time is unlimited",
    "Organization is useless"
  ],
  answer: "Planning improves efficiency"
},
{
  question: "Passage: Excessive use of mobile phones can negatively affect concentration and productivity.\n\nQuestion: Which is the best summary?",
  options: [
    "Too much phone use reduces productivity",
    "Phones improve concentration",
    "Phones are harmless",
    "Phones are necessary"
  ],
  answer: "Too much phone use reduces productivity"
},
{
  question: "Passage: Cooperation among workers leads to faster completion of tasks and better results.\n\nQuestion: Which is the best summary?",
  options: [
    "Cooperation improves results",
    "Workers should compete",
    "Tasks are difficult",
    "Results are random"
  ],
  answer: "Cooperation improves results"
},
{
  question: "Passage: Confidence helps individuals express themselves clearly and succeed in communication.\n\nQuestion: Which is the best summary?",
  options: [
    "Confidence improves communication",
    "Confidence causes failure",
    "Speaking is difficult",
    "Expression is unnecessary"
  ],
  answer: "Confidence improves communication"
},
{
  question: "Passage: Environmental conservation is necessary to protect natural resources for future generations.\n\nQuestion: Which is the best summary?",
  options: [
    "Conservation protects the future",
    "Resources are unlimited",
    "Environment is not important",
    "Future is uncertain"
  ],
  answer: "Conservation protects the future"
},

{
  question: "Which word has a different vowel sound?\n\nseat, beat, sit, meat",
  options: ["seat", "beat", "sit", "meat"],
  answer: "sit"
},
{
  question: "Which word has a different consonant sound?\n\nship, shop, chair, shoe",
  options: ["ship", "shop", "chair", "shoe"],
  answer: "chair"
},
{
  question: "Which word is stressed on the first syllable?",
  options: ["PHOtograph", "phoTOGraphy", "photoGRAphic", "phoTOgrapher"],
  answer: "PHOtograph"
},
{
  question: "Which word is stressed on the second syllable?",
  options: ["TAble", "beGIN", "DOCtor", "WINdow"],
  answer: "beGIN"
},
{
  question: "Which word has the /ʃ/ sound?",
  options: ["shoe", "see", "go", "tea"],
  answer: "shoe"
},
{
  question: "Which word has the /tʃ/ sound?",
  options: ["chair", "ship", "zoo", "sun"],
  answer: "chair"
},
{
  question: "Which word contains a diphthong?",
  options: ["boy", "cat", "pen", "sit"],
  answer: "boy"
},
{
  question: "Which word has the same vowel sound as 'cat'?",
  options: ["bat", "sit", "cut", "cot"],
  answer: "bat"
},
{
  question: "Which word has a silent letter?",
  options: ["knife", "dog", "cat", "run"],
  answer: "knife"
},
{
  question: "Which word ends with /ŋ/ sound?",
  options: ["sing", "sin", "sit", "sip"],
  answer: "sing"
},
{
  question: "Which word has stress on the last syllable?",
  options: ["enterTAIN", "TAble", "DOCtor", "WINdow"],
  answer: "enterTAIN"
},
{
  question: "Which word has the /θ/ sound?",
  options: ["think", "this", "that", "then"],
  answer: "think"
},
{
  question: "Which word has the /ð/ sound?",
  options: ["this", "think", "thin", "thank"],
  answer: "this"
},
{
  question: "Which word has a long vowel sound?",
  options: ["seat", "sit", "set", "sat"],
  answer: "seat"
},
{
  question: "Which word has a short vowel sound?",
  options: ["sit", "seat", "boot", "moon"],
  answer: "sit"
},
{
  question: "Which word is correctly stressed?",
  options: ["ecoNOmic", "EConomic", "ecoNOmics", "ECOnomics"],
  answer: "ecoNOmic"
},
{
  question: "Which word contains /k/ sound?",
  options: ["cat", "city", "circle", "cease"],
  answer: "cat"
},
{
  question: "Which word has different vowel sound?",
  options: ["food", "mood", "good", "pool"],
  answer: "good"
},
{
  question: "Which word contains /dʒ/ sound?",
  options: ["judge", "ship", "cat", "pen"],
  answer: "judge"
},
{
  question: "Which word has stress on the third syllable?",
  options: ["engiNEER", "ENgineer", "engineER", "ENgineER"],
  answer: "engiNEER"
},

{
  question: "Passage: An essay should have an introduction, body, and conclusion.\n\nQuestion: What is the purpose of the introduction?",
  options: [
    "to summarize",
    "to introduce the topic",
    "to give examples",
    "to conclude"
  ],
  answer: "to introduce the topic"
},
{
  question: "Passage: A good paragraph contains a topic sentence and supporting details.\n\nQuestion: What is the function of the topic sentence?",
  options: [
    "introduce the main idea",
    "end the paragraph",
    "give examples only",
    "repeat ideas"
  ],
  answer: "introduce the main idea"
},
{
  question: "Passage: Essays should be logically arranged to ensure clarity.\n\nQuestion: What does 'logically arranged' mean?",
  options: [
    "organized clearly",
    "random order",
    "confusing structure",
    "long sentences"
  ],
  answer: "organized clearly"
},
{
  question: "Passage: The conclusion summarizes the main points of the essay.\n\nQuestion: What is the role of the conclusion?",
  options: [
    "introduce topic",
    "summarize ideas",
    "add new ideas",
    "give examples"
  ],
  answer: "summarize ideas"
},
{
  question: "Passage: Linking words help connect ideas in writing.\n\nQuestion: What is the function of linking words?",
  options: [
    "connect ideas",
    "confuse readers",
    "end sentences",
    "repeat words"
  ],
  answer: "connect ideas"
},
{
  question: "Passage: Formal writing avoids slang and informal expressions.\n\nQuestion: What should be avoided in formal writing?",
  options: [
    "slang",
    "clear language",
    "correct grammar",
    "proper structure"
  ],
  answer: "slang"
},
{
  question: "Passage: Descriptive essays use vivid language to create images.\n\nQuestion: What is the purpose of vivid language?",
  options: [
    "create images",
    "confuse readers",
    "shorten essay",
    "repeat ideas"
  ],
  answer: "create images"
},
{
  question: "Passage: Argumentative essays require evidence to support claims.\n\nQuestion: Why is evidence important?",
  options: [
    "support arguments",
    "confuse readers",
    "reduce ideas",
    "avoid writing"
  ],
  answer: "support arguments"
},
{
  question: "Passage: Narrative essays tell a story in sequence.\n\nQuestion: What is important in narrative writing?",
  options: [
    "sequence",
    "random ideas",
    "no structure",
    "no conclusion"
  ],
  answer: "sequence"
},
{
  question: "Passage: Good writing uses correct punctuation to avoid confusion.\n\nQuestion: Why is punctuation important?",
  options: [
    "clarity",
    "length",
    "speed",
    "decoration"
  ],
  answer: "clarity"
},
{
  question: "Passage: Essays should stay focused on the topic.\n\nQuestion: What happens if an essay loses focus?",
  options: [
    "becomes unclear",
    "becomes better",
    "shorter",
    "easier"
  ],
  answer: "becomes unclear"
},
{
  question: "Passage: A good essay uses examples to support ideas.\n\nQuestion: What is the role of examples?",
  options: [
    "support ideas",
    "replace ideas",
    "confuse readers",
    "shorten essay"
  ],
  answer: "support ideas"
},
{
  question: "Passage: Editing helps improve grammar and clarity.\n\nQuestion: What is the purpose of editing?",
  options: [
    "improve writing",
    "reduce length",
    "add errors",
    "ignore mistakes"
  ],
  answer: "improve writing"
},
{
  question: "Passage: Unity in writing means all parts relate to the main idea.\n\nQuestion: What does unity ensure?",
  options: [
    "relevance",
    "confusion",
    "length",
    "random ideas"
  ],
  answer: "relevance"
},
{
  question: "Passage: Coherence means ideas flow smoothly.\n\nQuestion: What does coherence improve?",
  options: [
    "flow of ideas",
    "length",
    "grammar only",
    "punctuation only"
  ],
  answer: "flow of ideas"
},
{
  question: "Passage: A descriptive essay appeals to the senses.\n\nQuestion: What does this mean?",
  options: [
    "uses sensory details",
    "uses facts only",
    "uses arguments",
    "uses questions"
  ],
  answer: "uses sensory details"
},
{
  question: "Passage: Argumentative writing presents both sides before concluding.\n\nQuestion: Why present both sides?",
  options: [
    "balanced argument",
    "confusion",
    "long essay",
    "no reason"
  ],
  answer: "balanced argument"
},
{
  question: "Passage: A narrative should have a clear beginning, middle, and end.\n\nQuestion: What does this ensure?",
  options: [
    "structure",
    "confusion",
    "length",
    "difficulty"
  ],
  answer: "structure"
},
{
  question: "Passage: Topic relevance is important in essay writing.\n\nQuestion: What happens if ideas are irrelevant?",
  options: [
    "marks are lost",
    "marks increase",
    "essay improves",
    "no effect"
  ],
  answer: "marks are lost"
},
{
  question: "Passage: Clear expression helps readers understand ideas easily.\n\nQuestion: What is the benefit of clear expression?",
  options: [
    "better understanding",
    "confusion",
    "long writing",
    "complexity"
  ],
  answer: "better understanding"
},

{
  question: "Neither the teacher nor the students ___ ready.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "She ___ her homework before going out.",
  options: ["has finish", "has finished", "have finished", "had finishing"],
  answer: "has finished"
},
{
  question: "Choose the correct sentence:",
  options: [
    "He don’t like food",
    "He doesn’t likes food",
    "He doesn’t like food",
    "He not like food"
  ],
  answer: "He doesn’t like food"
},
{
  question: "He is fond ___ music.",
  options: ["of", "in", "on", "with"],
  answer: "of"
},
{
  question: "Choose the opposite of 'scarce':",
  options: ["abundant", "rare", "few", "little"],
  answer: "abundant"
},
{
  question: "She was very reluctant. 'Reluctant' means:",
  options: ["unwilling", "happy", "eager", "ready"],
  answer: "unwilling"
},
{
  question: "The news ___ shocking.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "One of the boys ___ missing.",
  options: ["are", "is", "were", "be"],
  answer: "is"
},
{
  question: "He apologized ___ being late.",
  options: ["for", "to", "with", "on"],
  answer: "for"
},
{
  question: "Choose the correct idiom: He kicked the bucket.",
  options: ["died", "ran", "won", "cried"],
  answer: "died"
},
{
  question: "Identify the error: She did not went there.",
  options: ["did", "not", "went", "there"],
  answer: "went"
},
{
  question: "Choose correct:",
  options: [
    "She is married with a doctor",
    "She is married to a doctor",
    "She is married by a doctor",
    "She is married from a doctor"
  ],
  answer: "She is married to a doctor"
},
{
  question: "The boys ___ playing outside.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "He is capable ___ doing the work.",
  options: ["of", "to", "for", "with"],
  answer: "of"
},
{
  question: "Choose synonym of 'concise':",
  options: ["brief", "long", "confusing", "dull"],
  answer: "brief"
},
{
  question: "Which word has /ʃ/ sound?",
  options: ["ship", "sip", "zip", "tip"],
  answer: "ship"
},
{
  question: "Which word has different vowel sound?",
  options: ["sit", "bit", "seat", "fit"],
  answer: "seat"
},
{
  question: "She ___ already left.",
  options: ["has", "have", "had", "having"],
  answer: "has"
},
{
  question: "Time and tide ___ for no man.",
  options: ["wait", "waits", "waiting", "waited"],
  answer: "wait"
},
{
  question: "Choose correct:",
  options: [
    "Between you and I",
    "Between you and me",
    "Between I and you",
    "Between me and I"
  ],
  answer: "Between you and me"
},

{
  question: "He is afraid ___ dogs.",
  options: ["of", "from", "with", "on"],
  answer: "of"
},
{
  question: "She ___ to school daily.",
  options: ["go", "goes", "went", "gone"],
  answer: "goes"
},
{
  question: "Choose antonym of 'expand':",
  options: ["contract", "grow", "increase", "develop"],
  answer: "contract"
},
{
  question: "He spoke as if he ___ everything.",
  options: ["knows", "knew", "known", "know"],
  answer: "knew"
},
{
  question: "Which has silent letter?",
  options: ["knife", "cat", "dog", "run"],
  answer: "knife"
},
{
  question: "She insisted ___ going.",
  options: ["on", "to", "for", "with"],
  answer: "on"
},
{
  question: "The police ___ investigating.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Choose correct idiom: once in a blue moon",
  options: ["rarely", "always", "daily", "often"],
  answer: "rarely"
},
{
  question: "He ___ never been there.",
  options: ["has", "have", "had", "having"],
  answer: "has"
},
{
  question: "Which word has /tʃ/?",
  options: ["chair", "ship", "sip", "zip"],
  answer: "chair"
},
{
  question: "The committee ___ divided.",
  options: ["is", "are", "was", "be"],
  answer: "are"
},
{
  question: "Choose synonym of 'arrogant':",
  options: ["proud", "humble", "kind", "gentle"],
  answer: "proud"
},
{
  question: "He denied ___ the money.",
  options: ["stealing", "to steal", "steal", "for stealing"],
  answer: "stealing"
},
{
  question: "Which word stressed first syllable?",
  options: ["PHOtograph", "phoTOGraphy", "photoGRAphic", "phoTOgrapher"],
  answer: "PHOtograph"
},
{
  question: "Choose correct:",
  options: [
    "She has less books",
    "She has fewer books",
    "She has little books",
    "She has small books"
  ],
  answer: "She has fewer books"
},
{
  question: "He is interested ___ science.",
  options: ["in", "on", "at", "with"],
  answer: "in"
},
{
  question: "The child ___ crying.",
  options: ["is", "are", "was", "be"],
  answer: "is"
},
{
  question: "Choose antonym of 'victory':",
  options: ["defeat", "success", "win", "triumph"],
  answer: "defeat"
},
{
  question: "He arrived ___ the station early.",
  options: ["at", "in", "on", "to"],
  answer: "at"
},
{
  question: "Which word has diphthong?",
  options: ["boy", "cat", "pen", "sit"],
  answer: "boy"
},

{
  question: "Passage: The character showed kindness despite being treated badly.\n\nQuestion: What literary trait is shown?",
  options: ["compassion", "greed", "anger", "fear"],
  answer: "compassion"
},
{
  question: "Passage: \"The sun smiled upon the land.\"\n\nQuestion: What literary device is used?",
  options: ["personification", "metaphor", "simile", "hyperbole"],
  answer: "personification"
},
{
  question: "Passage: \"He fought like a lion.\"\n\nQuestion: What device is used?",
  options: ["simile", "metaphor", "irony", "alliteration"],
  answer: "simile"
},
{
  question: "Passage: \"Time is a thief.\"\n\nQuestion: What device is used?",
  options: ["metaphor", "simile", "personification", "oxymoron"],
  answer: "metaphor"
},
{
  question: "Passage: The audience laughed at the character’s foolish actions.\n\nQuestion: What type of character is this?",
  options: ["comic", "heroic", "tragic", "villain"],
  answer: "comic"
},
{
  question: "Passage: He said, \"I will return tomorrow.\"\n\nQuestion: Which punctuation is correctly used?",
  options: ["quotation marks", "semicolon", "colon", "dash"],
  answer: "quotation marks"
},
{
  question: "Passage: The boy's book was missing.\n\nQuestion: What does the apostrophe show?",
  options: ["possession", "plural", "question", "exclamation"],
  answer: "possession"
},
{
  question: "Passage: Let's go to school.\n\nQuestion: What does the apostrophe indicate?",
  options: ["contraction", "possession", "plural", "question"],
  answer: "contraction"
},
{
  question: "Passage: Wow! That was amazing.\n\nQuestion: Which punctuation is used?",
  options: ["exclamation mark", "comma", "full stop", "colon"],
  answer: "exclamation mark"
},
{
  question: "Passage: I bought apples, oranges, and bananas.\n\nQuestion: What is the function of commas here?",
  options: ["list items", "pause only", "end sentence", "question"],
  answer: "list items"
},
{
  question: "Passage: Choose the correctly punctuated sentence.\n\nHe said ___ I am ready.",
  options: [
    "He said, \"I am ready.\"",
    "He said \"I am ready\"",
    "He said: I am ready",
    "He said I am ready"
  ],
  answer: "He said, \"I am ready.\""
},
{
  question: "Passage: The word 'record' (noun vs verb) changes stress.\n\nQuestion: Which is correct?",
  options: ["REcord (noun)", "reCORD (noun)", "REcord (verb)", "same stress"],
  answer: "REcord (noun)"
},
{
  question: "Passage: The word 'present' changes stress by meaning.\n\nQuestion: Which is verb form?",
  options: ["preSENT", "PREsent", "PRESENT", "same"],
  answer: "preSENT"
},
{
  question: "Passage: Which pair are minimal pairs?\n\nship / sheep",
  options: ["different vowel sound", "same sound", "same spelling", "none"],
  answer: "different vowel sound"
},
{
  question: "Passage: Which word has stress on second syllable?\n\nreLAX",
  options: ["correct", "incorrect"],
  answer: "correct"
},
{
  question: "Passage: \"The wind whispered through the trees.\"\n\nQuestion: What device is used?",
  options: ["personification", "metaphor", "simile", "irony"],
  answer: "personification"
},
{
  question: "Passage: The story ended sadly with the hero’s death.\n\nQuestion: What type of ending is this?",
  options: ["tragic", "comic", "happy", "neutral"],
  answer: "tragic"
},
{
  question: "Passage: He said he was coming.\n\nQuestion: This is an example of:",
  options: ["indirect speech", "direct speech", "question", "command"],
  answer: "indirect speech"
},
{
  question: "Passage: She said, \"I am tired.\"\n\nQuestion: This is:",
  options: ["direct speech", "indirect speech", "statement", "phrase"],
  answer: "direct speech"
},
{
  question: "Passage: Choose correct punctuation.\n\n___ are you going?",
  options: ["Where", "where", "WHERE", "were"],
  answer: "Where"
},

{
  question: "Passage: \"The stars danced in the night sky.\"\n\nQuestion: What literary device is used?",
  options: ["personification", "metaphor", "simile", "hyperbole"],
  answer: "personification"
},
{
  question: "Passage: \"Her voice was as sweet as honey.\"\n\nQuestion: Identify the device.",
  options: ["simile", "metaphor", "irony", "alliteration"],
  answer: "simile"
},
{
  question: "Passage: \"The classroom was a zoo.\"\n\nQuestion: What device is used?",
  options: ["metaphor", "simile", "personification", "pun"],
  answer: "metaphor"
},
{
  question: "Passage: The villain showed cruelty throughout the story.\n\nQuestion: What type of character is this?",
  options: ["antagonist", "protagonist", "comic", "hero"],
  answer: "antagonist"
},
{
  question: "Passage: The main character struggled but eventually succeeded.\n\nQuestion: What type of character is this?",
  options: ["protagonist", "villain", "minor", "comic"],
  answer: "protagonist"
},
{
  question: "Passage: \"The thunder roared loudly.\"\n\nQuestion: What device is used?",
  options: ["personification", "simile", "metaphor", "irony"],
  answer: "personification"
},
{
  question: "Passage: She said, \"Where are you going?\"\n\nQuestion: What punctuation marks are used?",
  options: ["quotation + question mark", "comma only", "semicolon", "colon"],
  answer: "quotation + question mark"
},
{
  question: "Passage: The girls' uniforms were neat.\n\nQuestion: The apostrophe shows:",
  options: ["plural possession", "singular possession", "contraction", "error"],
  answer: "plural possession"
},
{
  question: "Passage: It’s a beautiful day.\n\nQuestion: The apostrophe indicates:",
  options: ["contraction", "possession", "plural", "emphasis"],
  answer: "contraction"
},
{
  question: "Passage: Choose correct punctuation.\n\nMy brother who lives in Kumasi is visiting.",
  options: [
    "My brother, who lives in Kumasi, is visiting.",
    "My brother who lives, in Kumasi is visiting.",
    "My brother who lives in Kumasi, is visiting.",
    "My brother who lives in Kumasi is, visiting."
  ],
  answer: "My brother, who lives in Kumasi, is visiting."
},
{
  question: "Passage: Choose correct sentence.\n\nshe is going to school",
  options: [
    "She is going to school.",
    "she is going to school.",
    "She is going to school",
    "she Is going to school."
  ],
  answer: "She is going to school."
},
{
  question: "Passage: Which word has stress on the first syllable?\n\nTAble, beGIN, reLAX, deCIDE",
  options: ["TAble", "beGIN", "reLAX", "deCIDE"],
  answer: "TAble"
},
{
  question: "Passage: Which word has stress on the last syllable?\n\nenterTAIN, TAble, DOCtor, WINdow",
  options: ["enterTAIN", "TAble", "DOCtor", "WINdow"],
  answer: "enterTAIN"
},
{
  question: "Passage: Which pair has different vowel sounds?\n\npool / pull",
  options: ["different vowel sound", "same vowel sound", "same consonant", "none"],
  answer: "different vowel sound"
},
{
  question: "Passage: Which word contains /z/ sound?\n\nzoo, sip, tip, cat",
  options: ["zoo", "sip", "tip", "cat"],
  answer: "zoo"
},
{
  question: "Passage: \"He was so hungry he could eat a horse.\"\n\nQuestion: What device is used?",
  options: ["hyperbole", "simile", "metaphor", "personification"],
  answer: "hyperbole"
},
{
  question: "Passage: The story creates suspense before revealing the ending.\n\nQuestion: What technique is this?",
  options: ["suspense", "irony", "satire", "flashback"],
  answer: "suspense"
},
{
  question: "Passage: Choose correct punctuation.\n\nI have three goals study hard succeed and help others",
  options: [
    "I have three goals: study hard, succeed, and help others.",
    "I have three goals study hard succeed and help others.",
    "I have three goals; study hard succeed and help others.",
    "I have three goals study hard, succeed and help others"
  ],
  answer: "I have three goals: study hard, succeed, and help others."
},
{
  question: "Passage: Which word has silent 'b'?\n\nthumb, cat, run, sit",
  options: ["thumb", "cat", "run", "sit"],
  answer: "thumb"
},
{
  question: "Passage: Which word has the /f/ sound?\n\nphone, gone, tone, zone",
  options: ["phone", "gone", "tone", "zone"],
  answer: "phone"
},

{
  question: "Passage: The main character struggles against poverty but remains hopeful.\n\nQuestion: What is the central theme?",
  options: ["hope amidst hardship", "wealth", "anger", "fear"],
  answer: "hope amidst hardship"
},
{
  question: "Passage: The story is told from the narrator’s personal perspective using 'I'.\n\nQuestion: What narrative style is used?",
  options: ["first person", "third person", "omniscient", "dramatic"],
  answer: "first person"
},
{
  question: "Passage: The narrator knows the thoughts of all characters.\n\nQuestion: What point of view is this?",
  options: ["omniscient", "first person", "limited", "objective"],
  answer: "omniscient"
},
{
  question: "Passage: The story moves back to earlier events to explain a character’s past.\n\nQuestion: What technique is used?",
  options: ["flashback", "foreshadowing", "climax", "conflict"],
  answer: "flashback"
},
{
  question: "Passage: The turning point of the story where tension is highest.\n\nQuestion: What is this called?",
  options: ["climax", "exposition", "resolution", "theme"],
  answer: "climax"
},
{
  question: "Passage: The hero faces internal struggle about making a decision.\n\nQuestion: What type of conflict is this?",
  options: ["internal conflict", "external conflict", "social conflict", "physical conflict"],
  answer: "internal conflict"
},
{
  question: "Passage: \"The river swallowed the village whole.\"\n\nQuestion: What literary device is used?",
  options: ["personification", "metaphor", "simile", "irony"],
  answer: "metaphor"
},
{
  question: "Passage: \"The wind whispered softly.\"\n\nQuestion: Identify the device.",
  options: ["personification", "simile", "hyperbole", "alliteration"],
  answer: "personification"
},
{
  question: "Passage: \"He ran faster than the wind.\"\n\nQuestion: What device is used?",
  options: ["simile", "metaphor", "irony", "pun"],
  answer: "simile"
},
{
  question: "Passage: The poet describes nature using vivid sensory details.\n\nQuestion: What technique is used?",
  options: ["imagery", "irony", "satire", "dialogue"],
  answer: "imagery"
},
{
  question: "Passage: The poem expresses deep sadness about loss.\n\nQuestion: What is the tone?",
  options: ["sad", "joyful", "angry", "humorous"],
  answer: "sad"
},
{
  question: "Passage: The repeated use of consonant sounds at the beginning of words.\n\nQuestion: What is this device?",
  options: ["alliteration", "assonance", "metaphor", "irony"],
  answer: "alliteration"
},
{
  question: "Passage: Words that imitate natural sounds like 'buzz' and 'hiss'.\n\nQuestion: What device is this?",
  options: ["onomatopoeia", "imagery", "simile", "irony"],
  answer: "onomatopoeia"
},
{
  question: "Passage: A character who changes significantly during the story.\n\nQuestion: What type of character is this?",
  options: ["dynamic", "static", "minor", "flat"],
  answer: "dynamic"
},
{
  question: "Passage: A character who does not change throughout the story.\n\nQuestion: What type is this?",
  options: ["static", "dynamic", "round", "heroic"],
  answer: "static"
},
{
  question: "Passage: The author hints at events that will happen later.\n\nQuestion: What technique is used?",
  options: ["foreshadowing", "flashback", "climax", "conflict"],
  answer: "foreshadowing"
},
{
  question: "Passage: The events after the climax that lead to resolution.\n\nQuestion: What is this stage?",
  options: ["falling action", "rising action", "exposition", "theme"],
  answer: "falling action"
},
{
  question: "Passage: The lesson or message conveyed in a story.\n\nQuestion: What is this called?",
  options: ["theme", "plot", "character", "setting"],
  answer: "theme"
},
{
  question: "Passage: The time and place where a story occurs.\n\nQuestion: What is this element?",
  options: ["setting", "theme", "plot", "conflict"],
  answer: "setting"
},
{
  question: "Passage: The sequence of events in a story.\n\nQuestion: What is this called?",
  options: ["plot", "theme", "setting", "tone"],
  answer: "plot"
}

];

export default englishQuestions;
